import React from "react";
import { useTenant } from "../context/TenantContext";
import "../styles/about.css";

const About = () => {
  const { tenant } = useTenant();

  // Parse values from JSON string or array
  const getValues = () => {
    if (!tenant?.AboutValues) return [];

    if (typeof tenant.AboutValues === "string") {
      try {
        return JSON.parse(tenant.AboutValues);
      } catch (e) {
        return [];
      }
    }

    return Array.isArray(tenant.AboutValues) ? tenant.AboutValues : [];
  };

  const values = getValues();

  // Get the main about content (HTML from admin editor)
  const aboutContent = tenant?.AboutUsContent;

  // Check if we have custom content from the admin
  const hasCustomContent = aboutContent && aboutContent.trim() !== "";

  // If custom content exists, render it directly
  if (hasCustomContent) {
    return (
      <div className="about-page">
        <div className="container">
          <section className="about-hero">
            <h1>About {tenant?.BusinessName}</h1>
            <p>Learn more about who we are and what we stand for</p>
          </section>

          {/* Company Logo */}
          {tenant?.Logo && (
            <div className="about-logo-container">
              <img
                src={tenant.Logo}
                alt={tenant.BusinessName}
                className="about-logo"
              />
            </div>
          )}

          <div
            className="about-content"
            dangerouslySetInnerHTML={{ __html: aboutContent }}
          />
        </div>
      </div>
    );
  }

  // Default content using tenant data from backend
  return (
    <div className="about-page">
      <div className="container">
        <section className="about-hero">
          <h1>About {tenant?.BusinessName || "Us"}</h1>
          <p>Learn more about who we are and what we stand for</p>
        </section>

        {/* Company Logo */}
        {tenant?.Logo && (
          <div className="about-logo-container">
            <img
              src={tenant.Logo}
              alt={tenant.BusinessName}
              className="about-logo"
            />
          </div>
        )}

        {/* Our Story Section */}
        {tenant?.AboutStory ? (
          <div className="about-section">
            <h2>Our Story</h2>
            <div className="about-content-text">
              {tenant.AboutStory.split("\n").map((paragraph, idx) => (
                <p key={idx}>{paragraph}</p>
              ))}
            </div>
          </div>
        ) : (
          <div className="about-section">
            <h2>Our Story</h2>
            <p>
              Welcome to {tenant?.BusinessName || "our store"}! We are dedicated
              to providing high-quality products and exceptional customer
              service.
            </p>
            <p>
              Our journey began with a simple idea: to bring you the best
              products at competitive prices while ensuring a seamless shopping
              experience.
            </p>
          </div>
        )}

        {/* Our Mission Section */}
        {tenant?.AboutMission ? (
          <div className="about-section mission-section">
            <h2>Our Mission</h2>
            <div className="about-content-text">
              {tenant.AboutMission.split("\n").map((paragraph, idx) => (
                <p key={idx}>{paragraph}</p>
              ))}
            </div>
          </div>
        ) : (
          <div className="about-section mission-section">
            <h2>Our Mission</h2>
            <p>
              To provide exceptional products and services that enrich our
              customers' lives while maintaining the highest standards of
              integrity and quality.
            </p>
          </div>
        )}

        {/* Our Values Section */}
        {values.length > 0 ? (
          <div className="about-section values-section">
            <h2>Our Values</h2>
            <div className="values-grid">
              {values.map((value, index) => (
                <div key={index} className="value-card">
                  <div className="value-icon">✦</div>
                  <h3>{value}</h3>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="about-section values-section">
            <h2>Our Values</h2>
            <div className="values-grid">
              <div className="value-card">
                <div className="value-icon">✦</div>
                <h3>Quality First</h3>
              </div>
              <div className="value-card">
                <div className="value-icon">✦</div>
                <h3>Customer Focus</h3>
              </div>
              <div className="value-card">
                <div className="value-icon">✦</div>
                <h3>Fast Delivery</h3>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default About;